import { AllSkillsResponseModel, SkillsResponseModel } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { SkillsDTO } from './dto/skills.dto';
import { SkillsRequest } from './dto/skills.request';
import { SkillsService } from './skills.service';

@ApiTags('skills')
@Controller('skills')
export class SkillsController {

    constructor(
        private service: SkillsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createSkill')
    async createSkill(@Body() DTO: SkillsDTO, isUpdate: boolean = false): Promise<SkillsResponseModel>{
        try{
            return await this.service.createSkill(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(SkillsResponseModel, error);
        }
    }

    @Post('/updateSkill')
    async updateSkill(@Body() DTO: SkillsDTO, isUpdate: boolean = false): Promise<SkillsResponseModel>{
        try{
            return await this.service.createSkill(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(SkillsResponseModel, error);
        }
    }

    @Post('/getAllSkills')
    async getAllSkills(): Promise<AllSkillsResponseModel>{
        try{
            return await this.service.getAllSkills();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllSkillsResponseModel, error);
        }
    }

    @Post('/getAllActiveSkills')
    async getAllActiveSkills(): Promise<AllSkillsResponseModel>{
        try{
            return await this.service.getAllActiveSkills();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllSkillsResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateSkill')
    async activateOrDeactivateSkill(@Body() skillReq: SkillsRequest): Promise<SkillsResponseModel>{
        try{
            return await this.service.activateOrDeactivateSkill(skillReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(SkillsResponseModel, error);
        }
    }
}
